import { matchPath } from "react-router-dom";

// Routes every logged-in user can open, irrespective of the permission menu
const OPEN_ROUTES = ["/", "/logout", "/customer-lead-profile/:id"];

// QuickReportsWrapper checks access with its own menu API
const SELF_GUARDED_ROUTES = ["/report/quick-reports/*"];

// Pre-login pages (AppRouter); the URL is still on one of these right after login
const AUTH_ROUTES = ["/verify-otp", "/forgot-password", "/change-password", "/auto-login"];

// Pages opened from inside another page; allowed when their parent page is allowed
const CHILD_ROUTES = [
  { path: "/crm-management/user-list-add", parent: "/crm-management/users" },
  { path: "/crm-management/user-list-access/:userID", parent: "/crm-management/users" },
  { path: "/crm-management/user-list-update/:userID", parent: "/crm-management/users" },
  { path: "/lead-actions/manual-selfie-confirmation/:id", parent: "/lead-actions/manual-selfie-verification" },
];

const normalizePath = (path = "") => `/${path.trim().toLowerCase().replace(/^\/+|\/+$/g, "")}`;

const matchesAny = (patterns, pathname) => patterns.some((path) => matchPath({ path, end: true }, pathname));

// Collects the page links from the getUserPermission menu. Group links are skipped
// since they are only sidebar keys, not pages.
export const getAllowedRoutes = (menus = []) => {
  const links = (menus || [])
    .flatMap((item) => (item?.subMenu?.length ? item.subMenu : [item]))
    .map((item) => item?.link)
    .filter(Boolean)
    .map(normalizePath);

  return [...new Set(links)];
};

export const isAuthRoute = (pathname) => matchesAny(AUTH_ROUTES, pathname);

export const isUnguardedRoute = (pathname) => matchesAny([...OPEN_ROUTES, ...SELF_GUARDED_ROUTES], pathname);

export const isRouteAllowed = (pathname, allowedRoutes = []) => {
  if (isUnguardedRoute(pathname)) return true;

  const path = normalizePath(pathname);

  return allowedRoutes.some((route) => {
    if (route === "/") return path === "/";

    return (
      path === route ||
      // detail pages under an allowed page, e.g. /crm-management/roles-list/:role_id
      path.startsWith(`${route}/`) ||
      // layout routes that redirect to an allowed child, e.g. /report, /collection-manager
      route.startsWith(`${path}/`)
    );
  }) || CHILD_ROUTES.some(({ path: childPath, parent }) =>
    matchPath({ path: childPath, end: true }, pathname) && isRouteAllowed(parent, allowedRoutes)
  );
};
